<template>
 <div class="text-window">
    <b-row>
      <b-col sm="2">
        <b-input v-model="janFilter" ref="janFilter" @change="$emit('changeJanCodeFilter', $event)" size="sm" placeholder="JANコード検索"/>
      </b-col>
      <b-col sm="2">
        <b-input v-model="nameFilter" @change="$emit('changeNameFilter', $event)" size="sm" placeholder="ASIN/SKU/商品名"/>
      </b-col>
      <b-col sm="2">
        <b-input-group size="sm" prepend="商品サイズ">
          <b-select size="sm" v-model="sizeFilter" @change="$emit('changeSizeFilter', $event)" :options="sizeTypes"/>
        </b-input-group>
      </b-col>
      <b-col sm="2">
        <b-input-group size="sm" prepend="発送状況">
          <b-select size="sm" v-model="statusFilter" @change="$emit('changeShippingFilter', $event)" :options="shippingTypes"/>
        </b-input-group>
      </b-col>
      <b-col sm="2">
        <b-input-group size="sm" prepend="入庫状況">
          <b-select size="sm" v-model="inboundFilter" @change="$emit('changeInboundFilter', $event)" :options="inboundTypes"/>
        </b-input-group>
      </b-col>
      <b-col sm="1">
        <label class="label-pointer" size="sm" @click="$emit('changefilterMore', $event)">・・・</label>
      </b-col>
      <b-col sm="1">
        <b-button v-if="memberId !== 'slcuser6025' && memberId !== 'slcuser905' && memberId !== 'slcuserE047' && memberId !== 'slcuser1030' && memberId !== 'slcuserE022' && memberId !== 'slcuser009'" size="sm" @click="$emit('clearFilter')" variant="danger">解除</b-button>
        <b-button v-else size="sm" @click="$emit('searchAll')" variant="danger">全検索</b-button>
      </b-col>
    </b-row>
    <b-row v-show="displayfilterMore" class="mt-2">
      <b-col sm="2">
        <b-checkbox v-model="checkfilterInboundDate" button-variant="danger" @change="$emit('changeFilterInboundDate', $event)">入庫日検索</b-checkbox>
      </b-col>
      <b-col v-show="checkfilterInboundDate" class="zoom-back-1" sm="2">
        <date-picker id="startDate" :value="filterStartDate" @change="$emit('updateStartDate', $event)"/>
      </b-col>
      <b-col v-show="checkfilterInboundDate" class="zoom-back-1" sm="2">
        <date-picker id="endDate" :value="filterEndDate" @change="$emit('updateEndDate', $event)"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import SizeType from '@/types/SizeType';
import ShippingType from '@/types/ShippingType';
import InboundType from '@/types/InboundType';
import DatePicker from '@/components/common/DatePicker';

export default {
  mixins: [BaseComponent],
  props: {
    memberId: { default: ''},
    janFilter: { default: ''},
    nameFilter: { default: ''},
    sizeFilter: { default: '8' },
    statusFilter: { default: '1' },
    inboundFilter: { default: '0' },
    filterStartDate: { default: '' },
    filterEndDate: { default: '' },
    displayfilterMore: { default: false },
    checkfilterInboundDate: { default: true },
  },
  data() {
    return {
      sizeTypes: SizeType.filterValues(),
      shippingTypes: ShippingType.values(),
      inboundTypes: InboundType.values()
    };
  },
  methods: {
  }
};
Vue.component('date-picker', DatePicker);
</script>
